import React from 'react';
import { Result } from 'antd';

type ErrorResultProps = {
  code?: number;
  title?: string;
  subTitle?: string;
};

const ERROR_CODE_TO_TITLE_MAP = {
  401: 'Authorization Issue Detected',
  403: 'Permission Issue Detected',
  404: 'Resource not found',
  500: 'Something went wrong',
};

const ErrorResult: React.FC<ErrorResultProps> = ({ code, title, subTitle }) => (
  <Result
    status="error"
    title={
      title ||
      (ERROR_CODE_TO_TITLE_MAP as Record<string, string>)[String(code)] ||
      'Something went wrong'
    }
    subTitle={subTitle || 'Sorry, something went wrong. Please try again later'}
  />
);

export default ErrorResult;
